import {isTalentApp} from "../services/User.service";

const lang = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)
const result = lang.split("-")
const locale = isTalentApp() ? 'fr' : result[0]

export const defaultLocale = locale

export const locales = [
    {
        code: 'en',
        name: 'English',
        dir: 'ltr',
    },
    {
        code: 'fr',
        name: 'Français',
        dir: 'ltr',
    },
    {
        code: 'es',
        name: 'Español',
        dir: 'ltr',
    },
    {
        code: 'pl',
        name: 'Polsku',
        dir: 'ltr',
    },
    {
        code: 'it',
        name: 'Italiano',
        dir: 'ltr',
    },
    {
        code: 'de',
        name: 'Deutsch',
        dir: 'ltr',
    },
    {
        code: 'nl',
        name: 'Olandese',
        dir: 'ltr',
    },
    {
      code: 'qc',
      name: 'Québécois',
      dir: 'ltr',
    }
];



// WEBPACK FOOTER //
// ./src/plugins/i18n.js